var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),_c('product-list',{attrs:{"url":"/products/user_products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }